//通用insureConfig
//isShowNotices 是否显示投保前的提示 默认 false 为显示
export function initCustomInsureConfig() {
	return {
		type: -1,
		//如果更换方案，则之前保单替换显示通用名称,可以为空
		customName: '',
		name: [],
		currentId: [],
		isInsureCar: false,
		//默认false 显示
		isShowNotices: false,
		//投保限制地区 空：全国
		insureArea: '',
		//投保流程 是否展示PDF形式
		isShowPdfInsured: true,
		//批量替换
		isReplaceMore: true,
		//共同被保险人
		isShowInsuredList: false,
		//投保企业
		holder: {
			//是否只显示投保企业
			holderOnly: false,
			//个体户相关提示
			showSelfEmployed: false,
			//所属行业
			showIndustry: false,
			//企业类别
			showCategory: false,
			//证件类型
			showCertType: false,
			//邮件
			showEmail: false,
		},
		//方案
		plan: {
			//保额不足风险提示阈值
			coverageNotice: 0,
			//是否显示猝死选项
			insureSuddenDeath: false,
			//批增T + N
			insureAddMinDate: 1,
		},
		//期限
		period: {
			//可选择的保障期限
			periodList: [],
		},
		//发票
		invoice: {
			//能否开具增值税专用发票
			supportSpecialInvoice: true,
		},
		//投保人员
		employee: {
			//最少投保人员数量
			minEmployeeCount: 3,
			//批量上传模板下载链接
			employeeTemplate: [],
			//是否显示职业工种
			showEmployeeProfession: true,
			//职业工种三级代码编码规则
			professionLens: [2, 4, 7],
			professionFull: true,
		},
		//支付
		payOnline: {
			tips: '',
		},
		payOffline: {},
		//投保限制规则
		restriction: {},
	}
}

// Global config
export const globalConfig = {
	payOnline: {
		openWindowInside: true,
	},
}

// insureType
// 6--泛高空雇主
// 8--国寿财团意
// 9--亚太团意
// 10--电梯雇主
// 11--鼎和团意
// 12 安责险
// 13-- 美亚

export const insureConfig_3 = {
	type: 3,
	name: ['平安家居/充电桩安装运维工雇主险'],
	currentId: [216],
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: false,
	isShowInsuredList: false,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},
	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},
	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 1,
		//批量上传模板下载链接
		//是否显示职业工种
		showEmployeeProfession: false,
		//职业工种三级代码编码规则
		professionLens: [],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	insureName: '中国平安财产保险股份有限公司',
}

//275-全国普通
// 276-全国尊贵
//295 -全国普通年单
// 277-地方普通
// 278-地方尊贵
// 308，309，310，311对应 全国普通，全国尊贵，地区普通，地区尊贵
export const insureConfig_6 = {
	type: 6,
	//如果更换方案，则之前保单替换显示通用名称,可以为空
	customName: '太保高空行业雇主险',
	name: [
		'太保高空行业雇主险-低伤残低价版',
		'太保高空行业雇主险-低伤残低价版',
		'太保高空行业雇主险-低伤残低价版',
		'太保高空行业雇主险-低伤残低价版',
		'太保高空行业雇主险-低伤残低价版（年单特别版）',
		'太保高空行业雇主险-高伤残高价版',
		'太保高空行业雇主险-高伤残高价版',
		'太保高空行业雇主险-高伤残高价版',
		'太保高空行业雇主险-高伤残高价版',
		'太保钢结构工/设备拆除工雇主险-高伤残高价版',
		'太保光伏行业雇主险',
		'太保光伏行业雇主险',
		'太保光伏行业雇主险',
		'太保光伏行业雇主险',
		'太保钢结构工/设备拆除工雇主险-低伤残低价版',
		'太保门窗安装及制造雇主险',
		'太保门窗安装及制造雇主险',
		'太保门窗安装及制造雇主险',
		'太保门窗安装及制造雇主险',
	],
	currentId: [357, 359, 295, 358, 360, 352, 355, 356, 361, 362, 353, 364, 363],
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},
	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 100,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},
	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},
	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},
	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 7],
		professionFull: true,
	},
	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '中国太平洋保险股份有限公司',
}

export const insureConfig_7 = {
	type: 7,
	name: ['太保家电雇主险短期+24小时-高空'],
	currentId: [207],
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: false,
	//共同被保险人
	isShowInsuredList: true,
	// // 是否可以替换
	// isReplaceAble: '0',
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},
	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},
	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 1,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: false,
		//职业工种三级代码编码规则
		professionLens: [],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	insureName: '中国太平洋保险股份有限公司',
}

export const insureConfig_8 = {
	type: 8,
	name: ['国寿财高危行业4-6类团意险'],
	currentId: [220],
	isInsureCar: false,
	insureDisabled: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: true,
		//是否显示类别
		showCategory: false,
	},
	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		//是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 2,
	},
	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},
	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},
	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 5,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 7],
		professionFull: true,
	},
	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	insureName: '中国人寿财产保险股份有限公司',
}

export const insureConfig_9 = {
	type: 9,
	customName: '亚太1至4类团意险',
	name: ['亚太1-4类团意险普通医疗版（非高空）', '亚太1-4类团意险高端医疗版（非高空）'],
	currentId: [29, 30],
	isInsureCar: false,
	insureDisabled: true,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		//是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},
	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: false,
	},
	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [
			'https://file.meibaokeji.com/admin_process/profession_category/template_apiins_one_two.xlsx?v=90',
			'https://file.meibaokeji.com/admin_process/profession_category/template_apiins_three.xlsx?v=98',
			'https://file.meibaokeji.com/admin_process/profession_category/template_apiins_four.xlsx?v=97',
		],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [3, 5, 8],
		professionFull: false,
	},
	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {
		enabled: false,
	},
	insureName: '亚太财产保险股份有限公司',
}

export const insureConfig_10 = {
	type: 10,
	name: ['平安电梯/商业中央空调雇主险'],
	currentId: [31],
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},
	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 100,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},
	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},
	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},
	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 1,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: false,
		//职业工种三级代码编码规则
		professionLens: [],
		professionFull: true,
	},
	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	insureName: '中国平安财产保险股份有限公司',
}

export const insureConfig_11 = {
	type: 11,
	name: ['鼎和1-6类团意险'],
	currentId: [70, 71],
	isInsureCar: false,
	insureDisabled: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: true,
		idSuddenDeath: '71',
		insureAddMinDate: 1,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 5,
		//批量上传模板下载链接
		employeeTemplate: ['https://file.meibaokeji.com/admin_process/profession_category/template_edhic.xlsx'],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [3, 5, 7],
		professionFull: false,
	},
	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {
		enabled: false,
	},
	insureName: '鼎和财产保险股份有限公司',
}

/**
 * 298--新残标版
 * 299--工标版
 * 300--钢结构新残标版
 * 301--钢结构工标版
 * 302 泰康电力通信行业安责险新残标版20231120
 * 303 泰康电力通信行业安责险工标版
 */
//285 普通 标准
//286 普通 工标
//287 钢结构 标准
//288 钢结构 工标
export const insureConfig_12 = {
	type: 12,
	name: [
		'泰康建筑行业安责险',
		'泰康建筑行业安责险',
		'泰康建筑行业安责险-钢结构版',
		'泰康建筑行业安责险-钢结构版',
		'泰康电力通信行业安责险',
		'泰康电力通信行业安责险',
	],
	currentId: [343, 344, 345, 346, 348, 347],
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: true,
		// 是否显示类别
		showCategory: true,
	},
	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 100,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},
	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},
	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},
	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [3, 5, 8],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [
			// {
			//   professionLevels: null,
			//   professionCodes: '0706002',
			//   coverageList: null,
			//   termList: [12],
			//   message: '您选择的\"钢结构安装工\"工种，暂不支持投保年单。'
			// },
			// {
			//   professionLevels: null,
			//   professionCodes: '0701016',
			//   coverageList: null,
			//   termList: [12],
			//   message: '您选择的\"钢骨结构工人\"工种，暂不支持投保年单。'
			// },
			// {
			//   professionLevels: null,
			//   professionCodes: '0701028',
			//   coverageList: null,
			//   termList: [12],
			//   message: '您选择的\"机械设备拆除工\"工种，暂不支持投保年单。'
			// },
			// {
			//   professionLevels: null,
			//   professionCodes: null,
			//   coverageList: [120],
			//   termList: [12],
			//   message: '您选择的\"120万\"方案， 暂不支持投保年单。'
			// }
		],
	},
	insureName: '泰康在线财产保险股份有限公司',
}

export const insureConfig_13 = {
	type: 13,
	customName: '美亚1-6类团意险（C款）',
	name: ['美亚1-6类团意险（B款）', '美亚1-6类团意险（C款）', '美亚1-6类团意险（C款）'],
	currentId: [213, 304, 305],
	insureDisabled: false,
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: false,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},
	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},
	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},
	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},
	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [3, 5, 8],
		professionFull: false,
	},
	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	insureName: '美亚财产保险有限公司',
}

export const insureConfig_15 = {
	type: 15,
	name: ['前海1-4类雇主险'],
	currentId: [82],
	insureDisabled: false,
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 6],
		professionFull: false,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	insureName: '前海人寿保险股份有限公司',
}

export const insureConfig_14 = {
	type: 14,
	name: ['阳光驾乘人员意外险'],
	currentId: [81],
	insureDisabled: false,
	isInsureCar: true,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 0,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: false,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 6],
		professionFull: false,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	insureName: '阳光财产保险股份有限公司',
}

export const insureConfig_16 = {
	type: 16,
	name: ['太保建筑行业灵活用工保（限广东企业）'],
	currentId: [238],
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	insureArea: '',
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 100,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 7],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	insureName: '中国太平洋保险股份有限公司',
}

export const insureConfig_17 = {
	type: 17,
	name: ['太保家电雇主险+24小时-高空'],
	currentId: [316, 317],
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: false,
	isShowInsuredList: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},
	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},
	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 1,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: false,
		//职业工种三级代码编码规则
		professionLens: [],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	insureName: '中国太平洋保险股份有限公司',
}

export const insureConfig_18 = {
	type: 18,
	name: ['泰康电梯雇主险'],
	currentId: [97],
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [3, 5, 8],
		professionFull: false,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '泰康在线财产保险股份有限公司',
}

export const insureConfig_19 = {
	type: 19,
	name: ['太保制造行业1-6类雇主险（限广东企业）'],
	currentId: [273],
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: false,
	insureArea: '440000',
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 100,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [
			{
				label: '1年',
				value: 12,
			},
			{
				label: '6个月',
				value: 6,
			},
			{
				label: '3个月',
				value: 3,
			},
			{
				label: '1个月',
				value: 1,
			},
		],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 7],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	insureName: '中国太平洋保险股份有限公司',
}

export const insureConfig_21 = {
	type: 21,
	name: ['太保电梯安装维保人员雇主险'],
	currentId: [318],
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},
	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 100,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},
	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},
	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},
	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 7],
		professionFull: true,
	},
	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '中国太平洋保险股份有限公司',
}

export const insureConfig_22 = {
	type: 22,
	name: ['泰康1-5类雇主险'],
	currentId: [263, 264, 265, 266],
	isInsureCar: false,
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: true,
		// 是否显示类别
		showCategory: true,
	},
	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
		insureAddMinDate: 1,
	},
	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},
	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},
	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [3, 5, 8],
		professionFull: false,
	},
	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '泰康在线财产保险股份有限公司',
}

export const insureConfig_23 = {
	type: 23,
	name: ['阳光物流行业雇主险（限广东企业）'],
	isInsureCar: false,
	currentId: [269, 270],
	insureArea: '440000',
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 100,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 7],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '阳光财产保险股份有限公司',
}

export const insureConfig_24 = {
	type: 24,
	name: ['阳光建筑行业灵活用工保（限广东企业）'],
	isInsureCar: false,
	currentId: [232],
	insureArea: '440000',
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 100,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 7],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '阳光财产保险股份有限公司',
}

export const insureConfig_25 = {
	type: 25,
	name: ['阳光制造行业1-6类雇主险（限广东企业）'],
	isInsureCar: false,
	currentId: [233],
	insureArea: '440000',
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: false,
		//是否显示个体户相关提示
		showSelfEmployed: true,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 100,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: true,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 7],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '阳光财产保险股份有限公司',
}

export const insureConfig_29 = {
	type: 29,
	name: ['人保5至6类个人意外险（高空版）'],
	isInsureCar: false,
	currentId: [296],
	insureArea: '',
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: false,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 1,
		maxEmployeeCount: 1,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 6],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '中国人民财产保险股份有限公司',
}

export const insureConfig_36 = {
	type: 36,
	name: ['“灵工保”人保4-6类个意险'],
	isInsureCar: false,
	currentId: [425],
	insureArea: '',
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: false,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 1,
		maxEmployeeCount: 1,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 6],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '中国人民财产保险股份有限公司',
}

export const insureConfig_31 = {
	type: 31,
	name: ['平安光伏行业团意险'],
	isInsureCar: false,
	currentId: [312, 313],
	insureArea: '',
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: false,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 1,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 6],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '中国平安财产保险股份有限公司',
}

export const insureConfig_32 = {
	type: 32,
	name: ['太保1至5类团意险'],
	isInsureCar: false,
	currentId: [314],
	insureArea: '',
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: false,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 1,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 6],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '中国太平洋保险股份有限公司',
}

export const insureConfig_33 = {
	type: 33,
	name: ['利宝保险雇主责任保险（1-6类MB）'],
	isInsureCar: false,
	currentId: [338, 339],
	insureArea: '',
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: false,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 6],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '利宝保险有限公司',
}

export const insureConfig_34 = {
	type: 34,
	name: ['三星1-6类团意险'],
	isInsureCar: false,
	currentId: [365],
	insureArea: '',
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: false,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 6],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '三星财产保险（中国）有限公司',
}

export const insureConfig_37 = {
	type: 37,
	name: ['太保1-6类团意险'],
	isInsureCar: false,
	currentId: [437],
	insureArea: '',
	//投保流程 是否展示PDF形式
	isShowPdfInsured: true,
	//投保企业
	holder: {
		//是否只显示投保企业
		holderOnly: true,
		//是否显示个体户相关提示
		showSelfEmployed: false,
		//是否显示所属行业
		showIndustry: false,
		// 是否显示类别
		showCategory: false,
	},

	//方案
	plan: {
		//保额不足风险提示阈值
		coverageNotice: 0,
		// 是否显示猝死选项
		insureSuddenDeath: false,
	},

	//期限
	period: {
		//可选择的保障期限
		periodList: [],
	},

	//发票
	invoice: {
		//能否开具增值税专用发票
		supportSpecialInvoice: false,
	},

	//投保人员
	employee: {
		//最少投保人员数量
		minEmployeeCount: 3,
		//批量上传模板下载链接
		employeeTemplate: [],
		//是否显示职业工种
		showEmployeeProfession: true,
		//职业工种三级代码编码规则
		professionLens: [2, 4, 6],
		professionFull: true,
	},

	//支付
	payOnline: {
		tips: '',
	},
	payOffline: {},
	//投保限制规则
	restriction: {
		enabled: true,
		rules: [],
	},
	insureName: '中国太平洋财产保险有限公司',
}

export const insureMap = new Map([
	[insureConfig_3.type, insureConfig_3],
	[insureConfig_6.type, insureConfig_6],
	[insureConfig_7.type, insureConfig_7],
	[insureConfig_8.type, insureConfig_8],
	[insureConfig_9.type, insureConfig_9],
	[insureConfig_10.type, insureConfig_10],
	[insureConfig_11.type, insureConfig_11],
	[insureConfig_12.type, insureConfig_12],
	[insureConfig_13.type, insureConfig_13],
	[insureConfig_15.type, insureConfig_15],
	[insureConfig_14.type, insureConfig_14],
	[insureConfig_16.type, insureConfig_16],
	[insureConfig_17.type, insureConfig_17],
	[insureConfig_18.type, insureConfig_18],
	[insureConfig_19.type, insureConfig_19],
	[insureConfig_21.type, insureConfig_21],
	[insureConfig_22.type, insureConfig_22],
	[insureConfig_23.type, insureConfig_23],
	[insureConfig_24.type, insureConfig_24],
	[insureConfig_25.type, insureConfig_25],
	[insureConfig_29.type, insureConfig_29],
	[insureConfig_31.type, insureConfig_31],
	[insureConfig_32.type, insureConfig_32],
	[insureConfig_33.type, insureConfig_33],
	[insureConfig_34.type, insureConfig_34],
	[insureConfig_36.type, insureConfig_36],
	[insureConfig_37.type, insureConfig_37],
])
